function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import times from 'lodash/times';
import { getSignalFontVariantName } from '@signal/theme';
import { Wrapper, Skeleton } from './styles';
export var TypographySkeleton = function TypographySkeleton(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? undefined : _ref$style,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'body2' : _ref$variant,
      _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? 1 : _ref$lines,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'skeletonPrimary' : _ref$color,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? undefined : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? undefined : _ref$width,
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === void 0 ? undefined : _ref$inverse,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? undefined : _ref$align,
      rest = _objectWithoutProperties(_ref, ["style", "variant", "lines", "color", "fill", "width", "inverse", "align"]);

  return /*#__PURE__*/React.createElement(Wrapper, Object.assign({
    width: width,
    align: align
  }, rest), times(lines, function (i) {
    return /*#__PURE__*/React.createElement(Skeleton, {
      className: "pure-skeleton",
      key: i,
      styles: style,
      variant: getSignalFontVariantName(variant),
      color: color,
      last: i === lines - 1 && lines > 1,
      fill: fill,
      inverse: inverse,
      width: width
    });
  }));
};
TypographySkeleton.propTypes = {
  style: PropTypes.object,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.oneOf(['skeletonPrimary', 'skeletonDark', 'textPrimary', 'textSecondary', 'textDark', 'primary', 'secondary', 'success', 'error', 'inverse']),
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'body3', 'body4', 'caption']),
  lines: PropTypes.number,
  inverse: PropTypes.bool,
  fill: PropTypes.bool,
  align: PropTypes.oneOf(['left', 'center', 'right'])
};
TypographySkeleton.defaultProps = {
  variant: 'body2',
  lines: 1,
  color: 'skeletonPrimary'
};
export default TypographySkeleton;